import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var JobService = /** @class */ (function (_super) {
    tslib_1.__extends(JobService, _super);
    function JobService(http) {
        var _this = _super.call(this, http, MapperService.jobMap) || this;
        _this._endpoint = '/odata/Jobs';
        _this._mediaDownloadUrl = "/odata/ExecutionMedia/UiPath.Server.Configuration.OData.DownloadMediaByJobId";
        return _this;
    }
    JobService.prototype.startJobs = function (startProcessArgs) {
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.StartJobs";
        var payload = {
            'startInfo': {
                'ReleaseKey': startProcessArgs.releaseKey,
                'RobotIds': startProcessArgs.robotIds,
                'JobsCount': startProcessArgs.jobsCount,
                'Strategy': startProcessArgs.strategy,
                'InputArguments': startProcessArgs.inputArguments != null ?
                    JSON.stringify(startProcessArgs.inputArguments) :
                    null,
            },
        };
        return this._http.post(url, payload)
            .pipe(map(function () { return true; }));
    };
    JobService.prototype.stopJob = function (jobId, kill) {
        var action = 'UiPath.Server.Configuration.OData.StopJob';
        var payload = JSON.stringify({
            strategy: this._getStrategy(kill),
        });
        return this._http.post(this._endpoint + "(" + jobId + ")/" + action, payload)
            .pipe(map(function () { return true; }));
    };
    JobService.prototype.stopJobs = function (jobIds, kill) {
        var action = 'UiPath.Server.Configuration.OData.StopJobs';
        var payload = JSON.stringify({
            jobIds: jobIds,
            strategy: this._getStrategy(kill),
        });
        return this._http.post(this._endpoint + "/" + action, payload)
            .pipe(map(function () { return true; }));
    };
    JobService.prototype.resumeJob = function (jobKey) {
        var action = 'UiPath.Server.Configuration.OData.ResumeJob';
        var payload = JSON.stringify({
            jobKey: jobKey,
        });
        return this._http.post(this._endpoint + "/" + action, payload)
            .pipe(map(function () { return true; }));
    };
    JobService.prototype.getMediaDownloadUrl = function (job) {
        return this._mediaDownloadUrl + "(jobId=" + job.id + ")";
    };
    JobService.prototype._getStrategy = function (kill) {
        return (kill ? 2 /* Kill */ : 1 /* SoftStop */).toString();
    };
    return JobService;
}(ODataService));
export { JobService };
